/**
 * The four frontend origins and the landing-owned auth paths (D16).
 *
 * These live in their own module, rather than in routing.ts, because both routing.ts and
 * me.ts need them and routing.ts already imports types from me.ts — putting them in either
 * one would make the pair circular.
 *
 * The values are compile-time constants injected by each build (Vite `define`, Next `env`)
 * from packages/auth/origins.mjs. They are deliberately NOT runtime configuration: these are
 * redirect targets, and a redirect target anything at runtime can influence is an open
 * redirect.
 */

// Declared here rather than in an ambient .d.ts so the types travel with the module: every
// consumer that imports ORIGINS necessarily sees these, with no tsconfig `types` wiring.
declare global {
  const __MOST_ORIGIN_LANDING__: string;
  const __MOST_ORIGIN_BUYER__: string;
  const __MOST_ORIGIN_PRODUCER__: string;
  const __MOST_ORIGIN_ADMIN__: string;
}

/** Scheme+host, no trailing slash — e.g. "https://buyer.mostholding.org". */
export const ORIGINS = {
  landing: __MOST_ORIGIN_LANDING__,
  buyer: __MOST_ORIGIN_BUYER__,
  producer: __MOST_ORIGIN_PRODUCER__,
  admin: __MOST_ORIGIN_ADMIN__,
} as const;

/** The auth pages all live in the landing app, on the bare domain. */
export const LOGIN_PATH = `${ORIGINS.landing}/login`;
export const VERIFY_EMAIL_PATH = `${ORIGINS.landing}/verify-email`;
